module.exports = __webpack_public_path__ + "static/9-8d679847150e2add4b70fba06c19dee9.gif";